import http from '@/libs/AxiosPlugin'

const systemAuth = {
  get () {
    return http.get('/systemAuth/get')
  },

  update (code) {
    return http.post('/systemAuth/update', {code})
  }
}

export default systemAuth



// WEBPACK FOOTER //
// ./src/api/systemAuth.js